<template>
<div>
  <bread-crumb></bread-crumb>
  <div class="personal">
    <router-view></router-view>
  </div>
</div>
</template>

<script>
import breadCrumb from "@/components/breadCrumb";
  export default {
    name: "personalCenter.vue",
     components:{
      breadCrumb
    },
  }
</script>

<style scoped>
  .personal{
    background-color: #FFFFFF;
    padding: 20px;
  }
</style>
